// 引入 axios
import axios from "axios";



let base = 'http://125.124.156.90:8000';

//传送json格式的get请求
export const getRequest=(url,params)=>{
    return axios({
        method:'get',
        url:`/api/${url}`,
        data: params,
    })
}
